import { useState } from "react";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { useTranslation } from "@localization/useTranslation";
import { ApiKeyViewModel, CreateApiKeyResultViewModel } from "./ApiKeys.types";

export function useApiKeys() {
    const { translateString } = useTranslation();
    const query = useDotLegalQuery<Array<ApiKeyViewModel>>("/api-keys");
    const [showCreateDialog, setShowCreateDialog] = useState(false);
    const [createdResult, setCreatedResult] = useState<CreateApiKeyResultViewModel | undefined>(undefined);
    const [apiKeyForDeactivation, setApiKeyForDeactivation] = useState<ApiKeyViewModel | undefined>(undefined);

    const refetch = async () => {
        await query.refetch();
    };

    const onApiKeyCreated = async (result: CreateApiKeyResultViewModel) => {
        setShowCreateDialog(false);
        setCreatedResult(result);
        await refetch();
    };

    const onApiKeyDeactivated = async () => {
        setApiKeyForDeactivation(undefined);
        await refetch();
    };

    const getMenuItems = (apiKey: ApiKeyViewModel) => {
        if (!apiKey.isActive) return [];

        return [{ menuItem: translateString("deactivate"), onClick: () => setApiKeyForDeactivation(apiKey) }];
    };

    return {
        apiKeys: query.data,
        isLoading: query.isLoading,
        showCreateDialog,
        setShowCreateDialog,
        createdResult,
        setCreatedResult,
        apiKeyForDeactivation,
        closeDeactivateDialog: () => setApiKeyForDeactivation(undefined),
        getMenuItems,
        onApiKeyCreated,
        onApiKeyDeactivated,
    };
}
